import { Component, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CollectionService } from '@services/collection.service';
import { CreateNewStyleGroupComponent } from '../create-new-style-group/create-new-style-group.component';
import { MatDialog } from '@angular/material/dialog';
import { RoleManagementService } from '@services/role.management.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CreateNewStyleComponent } from '../create-new-style/create-new-style.component';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-style-group-details',
  templateUrl: './style-group-details.component.html',
  styleUrls: ['./style-group-details.component.scss']
})
export class StyleGroupDetailsComponent implements OnInit {
  @Input() styleGroupDetail: any;
  globalcollectionuuId: any;
  styleGroupDetails: any;
  displayedColumns: string[] = ['style', 'Updated', 'Action'];
  noDataFound: boolean = false;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) set content(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  deleteErrorMsg: any;
  @ViewChild('deleteError') private deleteError: TemplateRef<any>;
  private unsubscribe: Subject<void> = new Subject<void>();
  styleData: any = '';
  constructor(private CollectionService: CollectionService,public dialog: MatDialog,
    public roleSer: RoleManagementService,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    private translate: TranslateService,) {
    this.globalcollectionuuId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
  }

  ngOnInit(): void {
    this.CollectionService.getStyleGroupDetails(this.globalcollectionuuId, this.styleGroupDetail.styleGroupId).subscribe(data => {
      this.styleGroupDetails = data.data;
    });

    this.getStyleList();
  }

  getStyleList() {
    this.CollectionService.getStyleList(this.globalcollectionuuId, this.styleGroupDetail.styleGroupId).subscribe(data => {
      if (data.data.length > 0) {
        this.styleData = data.data;
        this.dataSource = new MatTableDataSource(data.data);
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          if(this.dataSource.paginator) {
            // ------Set translation for pagination------
            this.translate.stream([
              'collectionById.newStyle.pagination.pageLabel',
              'collectionById.newStyle.pagination.firstPage',
              'collectionById.newStyle.pagination.lastPage',
              'collectionById.newStyle.pagination.nextPage',
              'collectionById.newStyle.pagination.prevPage'
            ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                this.dataSource.paginator._intl.itemsPerPageLabel = translation['collectionById.newStyle.pagination.pageLabel'];
                this.dataSource.paginator._intl.firstPageLabel = translation['collectionById.newStyle.pagination.firstPage'];
                this.dataSource.paginator._intl.lastPageLabel = translation['collectionById.newStyle.pagination.lastPage'];
                this.dataSource.paginator._intl.nextPageLabel = translation['collectionById.newStyle.pagination.nextPage'];
                this.dataSource.paginator._intl.previousPageLabel = translation['collectionById.newStyle.pagination.prevPage'];

                this.dataSource.paginator._intl.changes.next();
            });
          }
        });

        this.noDataFound = false;
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.dataSource.paginator = this.paginator;
        this.noDataFound = true;
      }
    });
  }

  editStyleGroup() {
    const dialogSubscription = this.dialog.open(CreateNewStyleGroupComponent, { minWidth: '650px', data: {data: this.styleGroupDetails, styleGroupId: this.styleGroupDetail.styleGroupId}}).afterClosed().subscribe(result => {
      this.ngOnInit();
      dialogSubscription.unsubscribe();
    });
  }

  openStyleDialog(flag, data: any): void {
    const dialogSubscription = this.dialog.open(CreateNewStyleComponent, { minWidth: '650px', data: {type: flag, row: data, styleGroupId: this.styleGroupDetail.styleGroupId}}).afterClosed().subscribe(result => {
      this.getStyleList();
      dialogSubscription.unsubscribe();
    });
  }

  deleteStyle(row) {
    const dialogRef = this.dialog.open(DelMessageComponent, { data: { message: this.translate.instant('collectionById.editStyleGroup.deletePopup.message'), buttonText: { ok: this.translate.instant('collectionById.editStyleGroup.deletePopup.btnYes'), cancel: this.translate.instant('collectionById.editStyleGroup.deletePopup.btnNo') } } });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.CollectionService.deleteStyle(this.styleGroupDetail.styleGroupId, row.styleId).subscribe(data => {
          this.getStyleList();
          this.notificationService.success(data.message);
        }, (error: any) => {
          this.dialog.open(this.deleteError, {width: '700px'});
          this.deleteErrorMsg = error.error.message;
          // this.webErrorService.handleAPIErrors(error, '', true, 'warn');
        });
      }
    });
  }

  onBack() {
    this.CollectionService.onBackStyleGroupDetails.next(false);
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
